import { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface HelpTooltipProps {
  content: string;
  children?: ReactNode;
  side?: "top" | "bottom" | "left" | "right";
  className?: string;
  iconSize?: number;
}

export function HelpTooltip({
  content,
  children,
  side = "top",
  className,
  iconSize = 14,
}: HelpTooltipProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          {children || (
            <HelpCircle
              className={cn(
                "inline-block ml-1 text-muted-foreground hover:text-foreground transition-colors cursor-help",
                className
              )}
              size={iconSize}
            />
          )}
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-xs">
          <p className="text-sm">{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}